import { FormControl, FormHelperText, Grid } from "@mui/material";
import AutocompleteWithQuery from "components/AutocompleteWithQuery";
import Field from "components/Field";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  ListResponseOfState,
  State,
} from "services/KnowfullyAdminClient";
import { MetaValueFieldProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function StateDropdownField({
  metaValueName,
  index,
  attributeMetaValues,
}: MetaValueFieldProps) {
  const { formatMessage: t } = useIntl();
  const { stateService } = useGlobalContext();

  const fetchedData = useQuery<ListResponseOfState>(
    ["stateService.getStates"],
    () =>
      stateService.getStates(
        ListRequestOfBaseFilter.fromJS({ sortField: "stateName" }),
      ),
  );

  const existingValue = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  return (
    <>
      <Field
        name={`attributeMetaValues[${index}].name`}
        initialValue={metaValueName}
      >
        {() => null}
      </Field>
      <Field
        name={`attributeMetaValues[${index}].value`}
        initialValue={existingValue ?? ""}
      >
        {({ input, meta }) => (
          <Grid item xs={12}>
            <FormControl fullWidth error={meta.error && meta.submitFailed}>
              <AutocompleteWithQuery
                value={
                  input.value ? String(input.value).toLowerCase() : undefined
                }
                onChange={(id) => input.onChange(id ?? "")}
                fetchedData={fetchedData}
                labelField="stateName"
                getOptionLabel={(option: State) =>
                  option.name
                    ? `${option.stateName} (${option.name})`
                    : option.stateName ?? ""
                }
                label={t({ id: "locationFormStateLabel" })}
                failMessage={t({ id: "selectStatesFetchFailed" })}
                textFieldProps={{ error: meta.error && meta.submitFailed }}
              />
              {meta.error && meta.submitFailed && (
                <FormHelperText>{meta.error}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        )}
      </Field>
    </>
  );
}
